import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  signal,
  Type,
  ViewChild,
} from '@angular/core'
import {TranslocoService} from '@ngneat/transloco'
import {InformationDialogComponent} from '../../../../pages/pro/pro-settings-page/company-profile-page/information-dialog/information-dialog.component'
import {DialogService} from '../../../../craft/dialog/dialog.service'
import {faEllipsisVertical} from '@fortawesome/pro-solid-svg-icons/faEllipsisVertical'
import {Metric} from '../pro.directory.types'
import {PickedProperty} from '../../../../core/graphql/graphql-utils'

@Component({
  selector: 'bgo-pro-directory-card-metrics',
  templateUrl: './pro-directory-card-metrics.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  standalone: false,
})
export class ProDirectoryCardMetricsComponent {
  metrics = input.required<Metric[]>()
  parentContainerWidth = input.required<number>()

  protected readonly moreOrLessIcon = faEllipsisVertical
  protected readonly allMetricsShown = signal(false)
  protected readonly metricsContainerWidth = signal<number>(0)

  @ViewChild('metricsContainer') metricsContainer?: ElementRef<HTMLDivElement>

  constructor(
    private readonly dialogService: DialogService,
    private readonly translocoService: TranslocoService,
  ) {
    afterNextRender({
      read: () => {
        this.metricsContainerWidth.set(this.metricsContainer?.nativeElement.offsetWidth || 0)
      },
    })
  }

  showInfoDialog(information: string) {
    this.dialogService.show(InformationDialogComponent, {
      title: this.translocoService.translate('proDirectoryCard.infoDialogTitle'),
      info: information,
    })
  }

  showInfo(e: MouseEvent, info?: PickedProperty<Metric, 'info'>) {
    if (!info) return

    e.preventDefault()
    e.stopPropagation()
    this.showInfoDialog(this.translocoService.translate(info.localizedValue, info.params))
  }

  toggleShowAllMetrics(e: MouseEvent) {
    e.preventDefault()
    e.stopPropagation()
    this.allMetricsShown.set(!this.allMetricsShown())
  }

  isIconComponent(
    icon: PickedProperty<Metric, 'icon'>,
  ): icon is {component: Type<unknown>; inputs: Record<string, unknown>} {
    return !!icon && 'component' in icon
  }
}
